// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetOfferResponse

import { OfferEngineType } from './enums.gen';
import { hydrateWidgetOfferEventDate, type WidgetOfferEventDate, type WidgetOfferEventDateApiResponse } from './widgetOfferEventDate.gen';

export type WidgetOfferApiResponse = {
	id: string;
	name: string;
	sortOrder: number;
	from: string | null;
	to: string | null;
	minPax: number;
	maxPax: number;
	activityIds: Array<string>;
	image: string | null;
	presentation: string | null;
	shortDescription: string | null;
	collectionId: string;
	basePrice: number;
	maxFutureBookingTime: number | null;
	engine: OfferEngineType;
	eventDates: WidgetOfferEventDateApiResponse[];
};

export type WidgetOffer = {
	id: string;
	name: string;
	sortOrder: number;
	from: string | null;
	to: string | null;
	minPax: number;
	maxPax: number;
	activityIds: Array<string>;
	image: string | null;
	presentation: string | null;
	shortDescription: string | null;
	collectionId: string;
	basePrice: number;
	maxFutureBookingTime: number | null;
	engine: OfferEngineType;
	eventDates: WidgetOfferEventDate[];
};

export function hydrateWidgetOffer(data: WidgetOfferApiResponse): WidgetOffer {
	return {
		...data,
		eventDates: data.eventDates.map(hydrateWidgetOfferEventDate),
	};
}